import React, { useEffect } from "react"
import { motion, AnimatePresence } from "framer-motion"

import Button from "../comp/Button"
import ButtonConfirm from "../comp/ButtonConfirm"
import cx from "classnames"

const Confirm = ({
    comp,
    onYes,
    onNo,
    noText = "No",
    noMint = false,
    onCancel,
    noCancel,
    open,
    yesColor,
    yesText = "Yes",
    width = 410,
    singleClick,
    severe,
    className,
    imgComp,
    cancelText = "Cancel",
    colorFull,
}) => {
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Enter" && open) {
                event.preventDefault() // Prevent default Enter behavior (e.g., form submission)
                if (onYes) {
                    onYes() // Trigger the onYes callback
                }
            }
        }

        // Add event listener when the modal is open
        if (open) {
            window.addEventListener("keydown", handleKeyDown)
        }

        // Clean up the event listener when the modal closes or component unmounts
        return () => {
            window.removeEventListener("keydown", handleKeyDown)
        }
    }, [open, onYes]) // Re-run effect when open or onYes changes
    return (
        <>
            <AnimatePresence>
                {open && (
                    <motion.div
                        className={cx("dna-dark dna-confirm-panel dna-center-col", className, {
                            "color-full": colorFull,
                        })}
                        initial={{ width: width, marginLeft: -width / 2, transform: "translateY(-100%)", opacity: 0 }}
                        animate={{ transform: "translateY(0%)", opacity: 1 }}
                        exit={{ transform: "translateY(-100%)", opacity: 0 }}
                        transition={{ type: "spring", stiffness: 100 }}
                    >
                        {imgComp ? (
                            imgComp
                        ) : !severe ? (
                            <img src="/img/mAX.png" style={{ height: 70, marginBottom: 15 }} />
                        ) : (
                            <img
                                src="/img/astro-warning.png"
                                style={{ height: 120, marginLeft: 20, marginBottom: 20 }}
                            />
                        )}

                        {comp}

                        <div className="x-c-actions">
                            <div className="x-c-main-action-row">
                                {singleClick ? (
                                    <>
                                        <Button mint={!yesColor} red={yesColor === "red"} onClick={onYes}>
                                            {yesText}
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <ButtonConfirm mint={!yesColor} red={yesColor === "red"} onClick={onYes}>
                                            {yesText}
                                        </ButtonConfirm>
                                    </>
                                )}

                                {onNo && (
                                    <ButtonConfirm danger={!noMint} mint={noMint} onClick={onNo}>
                                        {noText}
                                    </ButtonConfirm>
                                )}
                            </div>
                            {!noCancel && (
                                <Button clear onClick={onCancel}>
                                    {cancelText}
                                </Button>
                            )}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
            {open && (
                <div
                    className="dna-modal "
                    style={{ pointerEvents: "all", zIndex: 99999999 }}
                    onClick={(e) => {
                        e.stopPropagation()
                    }}
                />
            )}
        </>
    )
}

export default Confirm
